// ── The reading ceremony timeline ─────────────────────────────────────────────
// One source of truth shared by the map stage (visual events) and the reading
// step (messages), so the two never drift apart.
//
// Design contract for this moment:
// - One visual event at a time. Messages live in the pauses between events.
// - Street reveals are deliberately irregular: uniform stagger reads as a
//   canned animation; irregular intervals read as relations being discovered.
// - Every timestamp is measured from the moment the user confirms the place.

export interface ReadingBeat {
  text: string;
  at: number;   // ms from ceremony start
  dur: number;  // ms visible (fade in + hold + fade out)
}

export const READING = {
  /** The confirmed block lights up — alone, after the city has settled. */
  cuadraAt: 3200,
  cuadraFade: 1400,

  /** Nearby streets appear one by one, at uneven intervals. */
  streetDelays: [5200, 6300, 7000, 8400, 9100, 10200],
  streetFade: 1100,

  /** One continuous, sub-perceptual zoom across the whole ceremony. */
  zoomMs: 14000,

  /** Territorial messages — they teach, they never describe the system. */
  messages: [
    { text: 'Cada lugar tiene una historia distinta.', at: 900, dur: 3300 },
    { text: 'Antes de hablar de valor, necesitamos comprender dónde está.', at: 4500, dur: 3400 },
    { text: 'El entorno explica gran parte del valor de una propiedad.', at: 8200, dur: 3100 },
  ] as ReadingBeat[],

  /** The discovery beat — the system found something worth reading. */
  discovery: {
    text: 'Encontramos señales que ayudan a entender esta cuadra.',
    at: 11600,
    dur: 3000,
  } as ReadingBeat,

  /** The reading panel rises after a short stillness. */
  total: 15000,
} as const;
